import type { ISearchUsersResponse } from "../types/user";

export const USER_QUERY_KEY = "user";

export const USER_PREFERENCES_QUERY_KEY = "user-preferences";

export const USER_SEARCH_QUERY_KEY = "user-search";

export const EMPTY_SEARCH_USERS_RESPONSE: ISearchUsersResponse = {
  projectMembers: [],
  organizationMembers: [],
};
